export default __webpack_public_path__ + "static/media/hostimg.edab52e6.svg";